var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-config-provider',{attrs:{"locale":_vm.locale}},[_c('div',{attrs:{"id":"app"}},[_c('router-view'),(_vm.showWatermark)?_c('div',{directives:[{name:"watermark",rawName:"v-watermark",value:({ watermarkText: _vm.watermarkText }),expression:"{ watermarkText: watermarkText }"}]}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }